export const Localization = [
  // arm
  {
    id: 0,
    value: 'arm',
    // menu
    main: 'Գլխավոր էջ',
    procedures: 'Պրոցեդուրաներ',
    news: 'Նորություններ',
    gallery: 'Նկարներ',
    aboutMe: 'Իմ մասին',
    contatMe: 'Կապ',
    // header
    doctorName: 'Գոռ Ամիրբեկյան',
    plasticSurgeon: 'Պլաստիկ վիրաբույժ, միկրովիրաբույժ',
    address: 'Հայաստան,Երեվան<br>Փ. Աբովյան 54',
    // footer
    footerHeading: 'Հետեւեք ինձ սոցիալական ցանցերում',
    author: 'Ստեղծել է Մկրտիչ․Մաթևոսյանը',
    // contact me
    yourName: 'Ձեր անունը',
    yourEmail: 'Ձեր էլ-փոստը',
    yourMsgHeading: 'Վերնագիր',
    yourMsg: 'Ձեր նամակը',
    sendMsg: 'Ուղարկել',
    sent: ' Ձեր նամակը ուղարկված է',
    // about me
    biography: 'Կենսագրություն',
    // gallery
    more: 'ավելին․․․',
    // news
    noNews: 'Այս պահին նորություններ չկան'
  },
  // rus
  {
    id: 1,
    value: 'rus',
    // menu
    main: 'Главная',
    procedures: 'Процедуры',
    news: 'Новости',
    gallery: 'Галерея',
    aboutMe: 'Обо мне',
    contatMe: 'Контакты',
    // header
    doctorName: 'Др. Гор Амирбекян',
    plasticSurgeon: 'Пластический хирург,микрохирург',
    address: 'Армения,Ереван<br>ул. Абовяна 54',
    // footer
    footerHeading: ' Следуй за мной в социальных сетях',
    author: 'Создал  Мкртыч Матевосян․',
    // contact me
    yourName: 'Ваше имя',
    yourEmail: 'Ваш электронный адрес',
    yourMsgHeading: 'Заголовок',
    yourMsg: 'Ваше письмо',
    sendMsg: 'Отправить',
    sent: 'Ваше письмо отправлено',
    // about me
    biography: 'Биография',
    // gallery
    more: 'больше․․․ ',
    // news
    noNews: 'Сейчас нет новостей'
  },
  // eng
  {
    id: 2,
    value: 'eng',
    main: 'Main page',
    procedures: 'Procedures',
    news: 'Gallery',
    aboutMe: 'About me',
    contatMe: 'Contact me',
    // header
    doctorName: 'Dr. Gor Amirbekyan',
    plasticSurgeon: 'Plastic surgeon,microsurgeon',
    address: 'Yerevan, Armenia<br>Abovyan str.54 ',
    // footer
    footerHeading: 'Follow me on social media',
    author: 'Created by Mkrtich Matevosyan․',
    // contact me
    yourName: 'Your Name',
    yourEmail: 'Your Email',
    yourMsgHeading: 'Subject',
    yourMsg: 'Your message',
    sendMsg: 'Send',
    sent: 'Your message sent',
    // about me
    biography: 'Biography',
    // gallery
    more: 'more...',
    // news
    noNews: 'There are no news right now'
  }
];
